import { render, staticRenderFns } from "./DownloadBox.vue?vue&type=template&id=4d097cdc&scoped=true"
import script from "./DownloadBox.vue?vue&type=script&lang=js"
export * from "./DownloadBox.vue?vue&type=script&lang=js"
import style0 from "./DownloadBox.vue?vue&type=style&index=0&id=4d097cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d097cdc",
  null
  
)

export default component.exports